import React, { Fragment, Component } from 'react';
import PropTypes from 'prop-types';

import SelectAccountIdentitiesContainer from '../../containers/discover/SelectAccountIdentitiesContainer';
import {
  hasSelectedAlbums,
  shouldDisplayBrandAttribution,
} from '../../util/discover-album-folder';
import Button from '../global/Button';
import PhotographerAttributionBanner from './PhotographerAttributionBanner';
import {
  albumFolderRequiresPhotoSearchOnboarding,
  isAlbumFolderTagSelectionRequiredForCheckout,
} from '../../util/album-folder';
import OnboardingLayoutFooter from '../../apps/temp/views/onboarding/OnboardingLayout/components/OnboardingLayoutFooter';
import { isAlbumFolderTagSelectionRequired } from '../../apps/temp/views/onboarding/TagSelection/helpers';
import IdentityTagSelectionModal, {
  IDENTITY_TAG_SELECTION_MODAL,
} from '../../apps/temp/views/onboarding/TagSelection/components/IdentityTagSelection/modal';

class DiscoverAlbumFolderFaces extends Component {
  static propTypes = {
    albumFolderId: PropTypes.string,
    onSelectIdentity: PropTypes.func.isRequired,
    resetAlbumDiscovery: PropTypes.func.isRequired,
    history: PropTypes.shape({
      push: PropTypes.func,
    }).isRequired,
    identities: PropTypes.arrayOf(
      PropTypes.shape({
        selectedAlbums: PropTypes.arrayOf(PropTypes.object).isRequired,
      }),
    ).isRequired,
    albumFolder: PropTypes.shape({
      album_type: PropTypes.string,
      album_subtype: PropTypes.string,
      account: PropTypes.object,
    }),
  };

  onIdentitySelected = identity => {
    const {
      albumFolderId,
      history,
      onSelectIdentity,
      albumFolder,
      openModal,
    } = this.props;

    onSelectIdentity({
      ...identity,
      selectedAlbums: [],
    });

    if (isAlbumFolderTagSelectionRequired(albumFolder.root)) {
      openModal(IDENTITY_TAG_SELECTION_MODAL, {
        onComplete: () => {
          history.push(`/discover/album-folder/${albumFolderId}/select`);
        },
      });

      return;
    }

    history.push(`/discover/album-folder/${albumFolderId}/select`);
  };

  onAlbumFolderPurchaseSubscription = identity => {
    const {
      history,
      albumFolder,
      resetAlbumDiscovery,
      onSelectIdentity,
    } = this.props;

    resetAlbumDiscovery();
    onSelectIdentity({
      ...identity,
      albumFolders: [albumFolder.root],
      selectedAlbums: [],
    });

    history.push({
      pathname: `/purchase/album-folder/${albumFolder.root.id}/purchase-summary`,
      state: { fromDiscovery: true },
    });
  };

  onComplete = () => {
    const { albumFolderId, albumFolder, history } = this.props;

    if (albumFolderRequiresPhotoSearchOnboarding(albumFolder)) {
      history.push(
        `/discover/album-folder/${albumFolder.id}/photo-search-checkout`,
      );
      return;
    }

    // #youthSports
    if (isAlbumFolderTagSelectionRequiredForCheckout(albumFolder)) {
      history.push(`/purchase/album-folder/${albumFolderId}/activities`);
      return;
    }

    history.push(`/discover/album-folder/${albumFolderId}/summary`);
  };

  render() {
    const {
      identity,
      identities,
      albumFolder,
      onDeselectIdentity,
    } = this.props;

    return (
      <Fragment>
        {shouldDisplayBrandAttribution(albumFolder) && (
          <PhotographerAttributionBanner account={albumFolder.account} />
        )}
        <SelectAccountIdentitiesContainer
          onSelectIdentity={this.onIdentitySelected}
          onPurchaseIdentity={this.onAlbumFolderPurchaseSubscription}
          useAlbumSelectionModal
        />
        <IdentityTagSelectionModal
          onDeselectIdentity={onDeselectIdentity}
          identity={identity}
          albumFolder={albumFolder}
        />
        {hasSelectedAlbums(identities) && (
          <OnboardingLayoutFooter>
            <Button btnSize="lg" className="mt-2" onClick={this.onComplete}>
              Continue
            </Button>
          </OnboardingLayoutFooter>
        )}
      </Fragment>
    );
  }
}

export default DiscoverAlbumFolderFaces;
